// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file cadendar/quotes/v1/quotes.proto (package cadendar.quotes.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cadendar/quotes/v1/quotes.proto.
 */
export const file_cadendar_quotes_v1_quotes: GenFile = /*@__PURE__*/
  fileDesc("Ch9jYWRlbmRhci9xdW90ZXMvdjEvcXVvdGVzLnByb3RvEhJjYWRlbmRhci5xdW90ZXMudjEiPwoXR2V0UGF0aWVudFF1b3Rlc1JlcXVlc3QSEAoIb3duZXJfaWQYASABKAkSEgoKcGF0aWVudF9pZBgCIAEoCSJMChhHZXRQYXRpZW50UXVvdGVzUmVzcG9uc2USMAoGcXVvdGVzGAEgAygLMiAuY2FkZW5kYXIucXVvdGVzLnYxLlBhdGllbnRRdW90ZSLAAQoTTGlzdFRyYWNraW5nUmVxdWVzdBIQCghvd25lcl9pZBgBIAEoCRIOCgZzZWFyY2gYAiABKAkSEgoFc3RhdGUYAyABKAlIAIgBARIRCgRmcm9tGAQgASgJSAGIAQESDwoCdG8YBSABKAlIAogBARIPCgdzb3J0X2J5GAYgASgJEhYKDnNvcnRfZGlyZWN0aW9uGAcgASgJEgwKBHBhZ2UYCCABKA1CCAoGX3N0YXRlQgcKBV9mcm9tQgUKA190byL7AQoVVXBkYXRlVHJhY2tpbmdSZXF1ZXN0EhAKCG93bmVyX2lkGAEgASgJEhAKCHF1b3RlX2lkGAIgASgJEg0KBXN0YXRlGAMgASgJEhsKDmVmZmVjdGl2ZV9kYXRlGAQgASgJSACIAQESGgoNZGVsaXZlcnlfZGF0ZRgFIAEoCUgBiAEBEhwKD2FjY2VwdGFuY2VfZGF0ZRgGIAEoCUgCiAEBEh8KF2V4cGVjdGVkX2hpc3RvcnlfbGVuZ3RoGAcgASgNQhEKD19lZmZlY3RpdmVfZGF0ZUIQCg5fZGVsaXZlcnlfZGF0ZUISChBfYWNjZXB0YW5jZV9kYXRlIvACCgxIaXN0b3J5RW50cnkSFgoOcHJldmlvdXNfc3RhdGUYASABKAkSDQoFc3RhdGUYAiABKAkSGwoOZWZmZWN0aXZlX2RhdGUYAyABKAlIAIgBARITCgtyZWNvcmRlZF9hdBgEIAEoCRIQCghhY3Rvcl9pZBgFIAEoCRIjChZwcmV2aW91c19kZWxpdmVyeV9kYXRlGAYgASgJSAGIAQESGgoNZGVsaXZlcnlfZGF0ZRgHIAEoCUgCiAEBEiUKGHByZXZpb3VzX2FjY2VwdGFuY2VfZGF0ZRgIIAEoCUgDiAEBEhwKD2FjY2VwdGFuY2VfZGF0ZRgJIAEoCUgEiAEBQhEKD19lZmZlY3RpdmVfZGF0ZUIZChdfcHJldmlvdXNfZGVsaXZlcnlfZGF0ZUIQCg5fZGVsaXZlcnlfZGF0ZUIbChlfcHJldmlvdXNfYWNjZXB0YW5jZV9kYXRlQhIKEF9hY2NlcHRhbmNlX2RhdGUirAEKCFRyYWNraW5nEg0KBXN0YXRlGAEgASgJEhoKDWRlbGl2ZXJ5X2RhdGUYAiABKAlIAIgBARIcCg9hY2NlcHRhbmNlX2RhdGUYAyABKAlIAYgBARIxCgdoaXN0b3J5GAQgAygLMiAuY2FkZW5kYXIucXVvdGVzLnYxLkhpc3RvcnlFbnRyeUIQCg5fZGVsaXZlcnlfZGF0ZUISChBfYWNjZXB0YW5jZV9kYXRlIuoBCg9SZWFsaXphdGlvbkxpbmUSDwoHbGluZV9pZBgBIAEoCRITCgtkZXNjcmlwdGlvbhgCIAEoCRIWCgljY2FtX2NvZGUYAyABKAlIAIgBARINCgV0ZWV0aBgEIAMoCRINCgVzdGF0ZRgFIAEoCRIUCgdhY3RlX2lkGAYgASgJSAGIAQESGwoOcGVyZm9ybWVkX2RhdGUYByABKAlIAogBARIbChNjb21wZXRpbmdfcXVvdGVfaWRzGAggAygJQgwKCl9jY2FtX2NvZGVCCgoIX2FjdGVfaWRCEQoPX3BlcmZvcm1lZF9kYXRlIsYCCgtSZWFsaXphdGlvbhINCgVzdGF0ZRgBIAEoCRITCgt0b3RhbF9saW5lcxgCIAEoDRIXCg9wZXJmb3JtZWRfbGluZXMYAyABKA0SFwoPYW1iaWd1b3VzX2xpbmVzGAQgASgNEhoKEnVudmVyaWZpYWJsZV9saW5lcxgFIAEoDRIcCg9jb21wbGV0aW9uX2RhdGUYBiABKAlIAIgBARIjCht3aXRob3V0X3JlY29yZGVkX2FjY2VwdGFuY2UYByABKAgSMgoFbGluZXMYCCADKAsyIy5jYWRlbmRhci5xdW90ZXMudjEuUmVhbGl6YXRpb25MaW5lEiEKFHRvdGFsX3BlcmZvcm1lZF9mZWVzGAkgASgJSAGIAQFCEgoQX2NvbXBsZXRpb25fZGF0ZUIXChVfdG90YWxfcGVyZm9ybWVkX2ZlZXMilAIKCVF1b3RlTGluZRIKCgJpZBgBIAEoCRITCgtkZXNjcmlwdGlvbhgCIAEoCRIWCgljY2FtX2NvZGUYAyABKAlIAIgBARINCgV0ZWV0aBgEIAMoCRIMCgRmZWVzGAUgASgJEgwKBGJhc2UYBiABKAkSCwoDYW1vGAcgASgJEgoKAnR4GAggASgBEhEKCW1hdGVyaWFscxgJIAEoCRIWCg5pc19hbHRlcm5hdGl2ZRgKIAEoCBIUCgdyYW5nX3ByGAsgASgFSAGIAQESFAoHcmFuZ19wdBgMIAEoBUgCiAEBEg0KBWluZGV4GA0gASgFQgwKCl9jY2FtX2NvZGVCCgoIX3JhbmdfcHJCCgoIX3JhbmdfcHQikAIKDFBhdGllbnRRdW90ZRIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEhUKDWNyZWF0aW9uX2RhdGUYAyABKAkSGgoNZGVsaXZlcnlfZGF0ZRgEIAEoCUgAiAEBEg0KBXN0YXRlGAUgASgJEiwKBWxpbmVzGAYgAygLMh0uY2FkZW5kYXIucXVvdGVzLnYxLlF1b3RlTGluZRIuCgh0cmFja2luZxgHIAEoCzIcLmNhZGVuZGFyLnF1b3Rlcy52MS5UcmFja2luZxI0CgtyZWFsaXphdGlvbhgIIAEoCzIfLmNhZGVuZGFyLnF1b3Rlcy52MS5SZWFsaXphdGlvbkIQCg5fZGVsaXZlcnlfZGF0ZSL8AQoLVHJhY2tpbmdSb3cSCgoCaWQYASABKAkSEgoKcGF0aWVudF9pZBgCIAEoCRIUCgxwYXRpZW50X25hbWUYAyABKAkSGAoQcGF0aWVudF9mb3JlbmFtZRgEIAEoCRIMCgRuYW1lGAUgASgJEhUKDWNyZWF0aW9uX2RhdGUYBiABKAkSEgoKdG90YWxfZmVlcxgHIAEoCRIuCgh0cmFja2luZxgIIAEoCzIcLmNhZGVuZGFyLnF1b3Rlcy52MS5UcmFja2luZxI0CgtyZWFsaXphdGlvbhgJIAEoCzIfLmNhZGVuZGFyLnF1b3Rlcy52MS5SZWFsaXphdGlvbiLUAgoNVHJhY2tpbmdTdGF0cxI9CgZjb3VudHMYASADKAsyLS5jYWRlbmRhci5xdW90ZXMudjEuVHJhY2tpbmdTdGF0cy5Db3VudHNFbnRyeRIRCglkZWxpdmVyZWQYAiABKA0SEAoIYWNjZXB0ZWQYAyABKA0SIQoZYWNjZXB0ZWRfZnJvbV9yZWFsaXphdGlvbhgEIAEoDRIcCg9hY2NlcHRhbmNlX3JhdGUYBSABKAFIAIgBARIiChphYmFuZG9uZWRfYWZ0ZXJfYWNjZXB0YW5jZRgGIAEoDRIdChVtaXNzaW5nX2RlbGl2ZXJ5X2RhdGUYByABKA0SGAoQZXhjbHVkZWRfaW52YWxpZBgIIAEoDRotCgtDb3VudHNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKA06AjgBQhIKEF9hY2NlcHRhbmNlX3JhdGUibgoQUmVhbGl6YXRpb25TdGF0cxIRCglwZXJmb3JtZWQYASABKA0SDwoHcGFydGlhbBgCIAEoDRIRCglhbWJpZ3VvdXMYAyABKA0SIwobd2l0aG91dF9yZWNvcmRlZF9hY2NlcHRhbmNlGAQgASgNItoBChRMaXN0VHJhY2tpbmdSZXNwb25zZRItCgRyb3dzGAEgAygLMh8uY2FkZW5kYXIucXVvdGVzLnYxLlRyYWNraW5nUm93Eg0KBXRvdGFsGAIgASgNEhEKCXBhZ2Vfc2l6ZRgDIAEoDRIwCgVzdGF0cxgEIAEoCzIhLmNhZGVuZGFyLnF1b3Rlcy52MS5UcmFja2luZ1N0YXRzEj8KEXJlYWxpemF0aW9uX3N0YXRzGAUgASgLMiQuY2FkZW5kYXIucXVvdGVzLnYxLlJlYWxpemF0aW9uU3RhdHMiMAoUQ3JlYXRlUXVvdGVMaW5lSW5wdXQSDAoEZmVlcxgBIAEoARIKCgJ0eBgCIAEoASJ9ChhDcmVhdGVRdW90ZUZhdm9yaXRlSW5wdXQSEwoLZmF2b3JpdGVfaWQYASABKAkSDQoFdGVldGgYAiADKA0SPQoLcXVvdGVfbGluZXMYAyADKAsyKC5jYWRlbmRhci5xdW90ZXMudjEuQ3JlYXRlUXVvdGVMaW5lSW5wdXQilwEKEkNyZWF0ZVF1b3RlUmVxdWVzdBIQCghvd25lcl9pZBgBIAEoCRISCgpwYXRpZW50X2lkGAIgASgJEhEKBG5hbWUYAyABKAlIAIgBARI/CglmYXZvcml0ZXMYBCADKAsyLC5jYWRlbmRhci5xdW90ZXMudjEuQ3JlYXRlUXVvdGVGYXZvcml0ZUlucHV0QgcKBV9uYW1lIiEKE0NyZWF0ZVF1b3RlUmVzcG9uc2USCgoCaWQYASABKAkiawoSSW1wb3J0TG9nb3NSZXF1ZXN0EhAKCG93bmVyX2lkGAEgASgJEhEKCWpzb25fZmlsZRgCIAEoCRIcCg9pbXBvcnRfYmF0Y2hfaWQYAyABKAlIAIgBAUISChBfaW1wb3J0X2JhdGNoX2lkImQKE0ltcG9ydExvZ29zUmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCBINCgVjb3VudBgCIAEoDRIWCg5pbnNlcnRlZF9jb3VudBgDIAEoDRIVCg11cGRhdGVkX2NvdW50GAQgASgNMucECg1RdW90ZXNTZXJ2aWNlEm0KEEdldFBhdGllbnRRdW90ZXMSKy5jYWRlbmRhci5xdW90ZXMudjEuR2V0UGF0aWVudFF1b3Rlc1JlcXVlc3QaLC5jYWRlbmRhci5xdW90ZXMudjEuR2V0UGF0aWVudFF1b3Rlc1Jlc3BvbnNlEmEKDExpc3RUcmFja2luZxInLmNhZGVuZGFyLnF1b3Rlcy52MS5MaXN0VHJhY2tpbmdSZXF1ZXN0GiguY2FkZW5kYXIucXVvdGVzLnYxLkxpc3RUcmFja2luZ1Jlc3BvbnNlElkKDlVwZGF0ZVRyYWNraW5nEikuY2FkZW5kYXIucXVvdGVzLnYxLlVwZGF0ZVRyYWNraW5nUmVxdWVzdBocLmNhZGVuZGFyLnF1b3Rlcy52MS5UcmFja2luZxJeCgtDcmVhdGVRdW90ZRImLmNhZGVuZGFyLnF1b3Rlcy52MS5DcmVhdGVRdW90ZVJlcXVlc3QaJy5jYWRlbmRhci5xdW90ZXMudjEuQ3JlYXRlUXVvdGVSZXNwb25zZRJkChFJbXBvcnRMb2dvc1F1b3RlcxImLmNhZGVuZGFyLnF1b3Rlcy52MS5JbXBvcnRMb2dvc1JlcXVlc3QaJy5jYWRlbmRhci5xdW90ZXMudjEuSW1wb3J0TG9nb3NSZXNwb25zZRJjChBJbXBvcnRMb2dvc0FjdGVzEiYuY2FkZW5kYXIucXVvdGVzLnYxLkltcG9ydExvZ29zUmVxdWVzdBonLmNhZGVuZGFyLnF1b3Rlcy52MS5JbXBvcnRMb2dvc1Jlc3BvbnNlYgZwcm90bzM");

/**
 * @generated from message cadendar.quotes.v1.GetPatientQuotesRequest
 */
export type GetPatientQuotesRequest = Message<"cadendar.quotes.v1.GetPatientQuotesRequest"> & {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;

  /**
   * @generated from field: string patient_id = 2;
   */
  patientId: string;
};

/**
 * Describes the message cadendar.quotes.v1.GetPatientQuotesRequest.
 * Use `create(GetPatientQuotesRequestSchema)` to create a new message.
 */
export const GetPatientQuotesRequestSchema: GenMessage<GetPatientQuotesRequest> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 0);

/**
 * @generated from message cadendar.quotes.v1.GetPatientQuotesResponse
 */
export type GetPatientQuotesResponse = Message<"cadendar.quotes.v1.GetPatientQuotesResponse"> & {
  /**
   * @generated from field: repeated cadendar.quotes.v1.PatientQuote quotes = 1;
   */
  quotes: PatientQuote[];
};

/**
 * Describes the message cadendar.quotes.v1.GetPatientQuotesResponse.
 * Use `create(GetPatientQuotesResponseSchema)` to create a new message.
 */
export const GetPatientQuotesResponseSchema: GenMessage<GetPatientQuotesResponse> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 1);

/**
 * @generated from message cadendar.quotes.v1.ListTrackingRequest
 */
export type ListTrackingRequest = Message<"cadendar.quotes.v1.ListTrackingRequest"> & {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;

  /**
   * @generated from field: string search = 2;
   */
  search: string;

  /**
   * @generated from field: optional string state = 3;
   */
  state?: string | undefined;

  /**
   * @generated from field: optional string from = 4;
   */
  from?: string | undefined;

  /**
   * @generated from field: optional string to = 5;
   */
  to?: string | undefined;

  /**
   * @generated from field: string sort_by = 6;
   */
  sortBy: string;

  /**
   * @generated from field: string sort_direction = 7;
   */
  sortDirection: string;

  /**
   * @generated from field: uint32 page = 8;
   */
  page: number;
};

/**
 * Describes the message cadendar.quotes.v1.ListTrackingRequest.
 * Use `create(ListTrackingRequestSchema)` to create a new message.
 */
export const ListTrackingRequestSchema: GenMessage<ListTrackingRequest> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 2);

/**
 * @generated from message cadendar.quotes.v1.UpdateTrackingRequest
 */
export type UpdateTrackingRequest = Message<"cadendar.quotes.v1.UpdateTrackingRequest"> & {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;

  /**
   * @generated from field: string quote_id = 2;
   */
  quoteId: string;

  /**
   * @generated from field: string state = 3;
   */
  state: string;

  /**
   * @generated from field: optional string effective_date = 4;
   */
  effectiveDate?: string | undefined;

  /**
   * @generated from field: optional string delivery_date = 5;
   */
  deliveryDate?: string | undefined;

  /**
   * @generated from field: optional string acceptance_date = 6;
   */
  acceptanceDate?: string | undefined;

  /**
   * @generated from field: uint32 expected_history_length = 7;
   */
  expectedHistoryLength: number;
};

/**
 * Describes the message cadendar.quotes.v1.UpdateTrackingRequest.
 * Use `create(UpdateTrackingRequestSchema)` to create a new message.
 */
export const UpdateTrackingRequestSchema: GenMessage<UpdateTrackingRequest> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 3);

/**
 * @generated from message cadendar.quotes.v1.HistoryEntry
 */
export type HistoryEntry = Message<"cadendar.quotes.v1.HistoryEntry"> & {
  /**
   * @generated from field: string previous_state = 1;
   */
  previousState: string;

  /**
   * @generated from field: string state = 2;
   */
  state: string;

  /**
   * @generated from field: optional string effective_date = 3;
   */
  effectiveDate?: string | undefined;

  /**
   * @generated from field: string recorded_at = 4;
   */
  recordedAt: string;

  /**
   * @generated from field: string actor_id = 5;
   */
  actorId: string;

  /**
   * @generated from field: optional string previous_delivery_date = 6;
   */
  previousDeliveryDate?: string | undefined;

  /**
   * @generated from field: optional string delivery_date = 7;
   */
  deliveryDate?: string | undefined;

  /**
   * @generated from field: optional string previous_acceptance_date = 8;
   */
  previousAcceptanceDate?: string | undefined;

  /**
   * @generated from field: optional string acceptance_date = 9;
   */
  acceptanceDate?: string | undefined;
};

/**
 * Describes the message cadendar.quotes.v1.HistoryEntry.
 * Use `create(HistoryEntrySchema)` to create a new message.
 */
export const HistoryEntrySchema: GenMessage<HistoryEntry> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 4);

/**
 * @generated from message cadendar.quotes.v1.Tracking
 */
export type Tracking = Message<"cadendar.quotes.v1.Tracking"> & {
  /**
   * @generated from field: string state = 1;
   */
  state: string;

  /**
   * @generated from field: optional string delivery_date = 2;
   */
  deliveryDate?: string | undefined;

  /**
   * @generated from field: optional string acceptance_date = 3;
   */
  acceptanceDate?: string | undefined;

  /**
   * @generated from field: repeated cadendar.quotes.v1.HistoryEntry history = 4;
   */
  history: HistoryEntry[];
};

/**
 * Describes the message cadendar.quotes.v1.Tracking.
 * Use `create(TrackingSchema)` to create a new message.
 */
export const TrackingSchema: GenMessage<Tracking> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 5);

/**
 * @generated from message cadendar.quotes.v1.RealizationLine
 */
export type RealizationLine = Message<"cadendar.quotes.v1.RealizationLine"> & {
  /**
   * @generated from field: string line_id = 1;
   */
  lineId: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: optional string ccam_code = 3;
   */
  ccamCode?: string | undefined;

  /**
   * @generated from field: repeated string teeth = 4;
   */
  teeth: string[];

  /**
   * @generated from field: string state = 5;
   */
  state: string;

  /**
   * @generated from field: optional string acte_id = 6;
   */
  acteId?: string | undefined;

  /**
   * @generated from field: optional string performed_date = 7;
   */
  performedDate?: string | undefined;

  /**
   * @generated from field: repeated string competing_quote_ids = 8;
   */
  competingQuoteIds: string[];
};

/**
 * Describes the message cadendar.quotes.v1.RealizationLine.
 * Use `create(RealizationLineSchema)` to create a new message.
 */
export const RealizationLineSchema: GenMessage<RealizationLine> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 6);

/**
 * @generated from message cadendar.quotes.v1.Realization
 */
export type Realization = Message<"cadendar.quotes.v1.Realization"> & {
  /**
   * @generated from field: string state = 1;
   */
  state: string;

  /**
   * @generated from field: uint32 total_lines = 2;
   */
  totalLines: number;

  /**
   * @generated from field: uint32 performed_lines = 3;
   */
  performedLines: number;

  /**
   * @generated from field: uint32 ambiguous_lines = 4;
   */
  ambiguousLines: number;

  /**
   * @generated from field: uint32 unverifiable_lines = 5;
   */
  unverifiableLines: number;

  /**
   * @generated from field: optional string completion_date = 6;
   */
  completionDate?: string | undefined;

  /**
   * @generated from field: bool without_recorded_acceptance = 7;
   */
  withoutRecordedAcceptance: boolean;

  /**
   * @generated from field: repeated cadendar.quotes.v1.RealizationLine lines = 8;
   */
  lines: RealizationLine[];

  /**
   * Sum of actual amounts of uniquely matched acts, in euros (decimal string).
   *
   * @generated from field: optional string total_performed_fees = 9;
   */
  totalPerformedFees?: string | undefined;
};

/**
 * Describes the message cadendar.quotes.v1.Realization.
 * Use `create(RealizationSchema)` to create a new message.
 */
export const RealizationSchema: GenMessage<Realization> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 7);

/**
 * @generated from message cadendar.quotes.v1.QuoteLine
 */
export type QuoteLine = Message<"cadendar.quotes.v1.QuoteLine"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: optional string ccam_code = 3;
   */
  ccamCode?: string | undefined;

  /**
   * @generated from field: repeated string teeth = 4;
   */
  teeth: string[];

  /**
   * @generated from field: string fees = 5;
   */
  fees: string;

  /**
   * @generated from field: string base = 6;
   */
  base: string;

  /**
   * @generated from field: string amo = 7;
   */
  amo: string;

  /**
   * @generated from field: double tx = 8;
   */
  tx: number;

  /**
   * @generated from field: string materials = 9;
   */
  materials: string;

  /**
   * @generated from field: bool is_alternative = 10;
   */
  isAlternative: boolean;

  /**
   * @generated from field: optional int32 rang_pr = 11;
   */
  rangPr?: number | undefined;

  /**
   * @generated from field: optional int32 rang_pt = 12;
   */
  rangPt?: number | undefined;

  /**
   * @generated from field: int32 index = 13;
   */
  index: number;
};

/**
 * Describes the message cadendar.quotes.v1.QuoteLine.
 * Use `create(QuoteLineSchema)` to create a new message.
 */
export const QuoteLineSchema: GenMessage<QuoteLine> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 8);

/**
 * @generated from message cadendar.quotes.v1.PatientQuote
 */
export type PatientQuote = Message<"cadendar.quotes.v1.PatientQuote"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string creation_date = 3;
   */
  creationDate: string;

  /**
   * @generated from field: optional string delivery_date = 4;
   */
  deliveryDate?: string | undefined;

  /**
   * @generated from field: string state = 5;
   */
  state: string;

  /**
   * @generated from field: repeated cadendar.quotes.v1.QuoteLine lines = 6;
   */
  lines: QuoteLine[];

  /**
   * @generated from field: cadendar.quotes.v1.Tracking tracking = 7;
   */
  tracking?: Tracking | undefined;

  /**
   * @generated from field: cadendar.quotes.v1.Realization realization = 8;
   */
  realization?: Realization | undefined;
};

/**
 * Describes the message cadendar.quotes.v1.PatientQuote.
 * Use `create(PatientQuoteSchema)` to create a new message.
 */
export const PatientQuoteSchema: GenMessage<PatientQuote> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 9);

/**
 * @generated from message cadendar.quotes.v1.TrackingRow
 */
export type TrackingRow = Message<"cadendar.quotes.v1.TrackingRow"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string patient_id = 2;
   */
  patientId: string;

  /**
   * @generated from field: string patient_name = 3;
   */
  patientName: string;

  /**
   * @generated from field: string patient_forename = 4;
   */
  patientForename: string;

  /**
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * @generated from field: string creation_date = 6;
   */
  creationDate: string;

  /**
   * @generated from field: string total_fees = 7;
   */
  totalFees: string;

  /**
   * @generated from field: cadendar.quotes.v1.Tracking tracking = 8;
   */
  tracking?: Tracking | undefined;

  /**
   * @generated from field: cadendar.quotes.v1.Realization realization = 9;
   */
  realization?: Realization | undefined;
};

/**
 * Describes the message cadendar.quotes.v1.TrackingRow.
 * Use `create(TrackingRowSchema)` to create a new message.
 */
export const TrackingRowSchema: GenMessage<TrackingRow> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 10);

/**
 * @generated from message cadendar.quotes.v1.TrackingStats
 */
export type TrackingStats = Message<"cadendar.quotes.v1.TrackingStats"> & {
  /**
   * @generated from field: map<string, uint32> counts = 1;
   */
  counts: { [key: string]: number };

  /**
   * @generated from field: uint32 delivered = 2;
   */
  delivered: number;

  /**
   * @generated from field: uint32 accepted = 3;
   */
  accepted: number;

  /**
   * @generated from field: uint32 accepted_from_realization = 4;
   */
  acceptedFromRealization: number;

  /**
   * @generated from field: optional double acceptance_rate = 5;
   */
  acceptanceRate?: number | undefined;

  /**
   * @generated from field: uint32 abandoned_after_acceptance = 6;
   */
  abandonedAfterAcceptance: number;

  /**
   * @generated from field: uint32 missing_delivery_date = 7;
   */
  missingDeliveryDate: number;

  /**
   * @generated from field: uint32 excluded_invalid = 8;
   */
  excludedInvalid: number;
};

/**
 * Describes the message cadendar.quotes.v1.TrackingStats.
 * Use `create(TrackingStatsSchema)` to create a new message.
 */
export const TrackingStatsSchema: GenMessage<TrackingStats> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 11);

/**
 * @generated from message cadendar.quotes.v1.RealizationStats
 */
export type RealizationStats = Message<"cadendar.quotes.v1.RealizationStats"> & {
  /**
   * @generated from field: uint32 performed = 1;
   */
  performed: number;

  /**
   * @generated from field: uint32 partial = 2;
   */
  partial: number;

  /**
   * @generated from field: uint32 ambiguous = 3;
   */
  ambiguous: number;

  /**
   * @generated from field: uint32 without_recorded_acceptance = 4;
   */
  withoutRecordedAcceptance: number;
};

/**
 * Describes the message cadendar.quotes.v1.RealizationStats.
 * Use `create(RealizationStatsSchema)` to create a new message.
 */
export const RealizationStatsSchema: GenMessage<RealizationStats> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 12);

/**
 * @generated from message cadendar.quotes.v1.ListTrackingResponse
 */
export type ListTrackingResponse = Message<"cadendar.quotes.v1.ListTrackingResponse"> & {
  /**
   * @generated from field: repeated cadendar.quotes.v1.TrackingRow rows = 1;
   */
  rows: TrackingRow[];

  /**
   * @generated from field: uint32 total = 2;
   */
  total: number;

  /**
   * @generated from field: uint32 page_size = 3;
   */
  pageSize: number;

  /**
   * @generated from field: cadendar.quotes.v1.TrackingStats stats = 4;
   */
  stats?: TrackingStats | undefined;

  /**
   * @generated from field: cadendar.quotes.v1.RealizationStats realization_stats = 5;
   */
  realizationStats?: RealizationStats | undefined;
};

/**
 * Describes the message cadendar.quotes.v1.ListTrackingResponse.
 * Use `create(ListTrackingResponseSchema)` to create a new message.
 */
export const ListTrackingResponseSchema: GenMessage<ListTrackingResponse> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 13);

/**
 * @generated from message cadendar.quotes.v1.CreateQuoteLineInput
 */
export type CreateQuoteLineInput = Message<"cadendar.quotes.v1.CreateQuoteLineInput"> & {
  /**
   * @generated from field: double fees = 1;
   */
  fees: number;

  /**
   * @generated from field: double tx = 2;
   */
  tx: number;
};

/**
 * Describes the message cadendar.quotes.v1.CreateQuoteLineInput.
 * Use `create(CreateQuoteLineInputSchema)` to create a new message.
 */
export const CreateQuoteLineInputSchema: GenMessage<CreateQuoteLineInput> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 14);

/**
 * @generated from message cadendar.quotes.v1.CreateQuoteFavoriteInput
 */
export type CreateQuoteFavoriteInput = Message<"cadendar.quotes.v1.CreateQuoteFavoriteInput"> & {
  /**
   * @generated from field: string favorite_id = 1;
   */
  favoriteId: string;

  /**
   * @generated from field: repeated uint32 teeth = 2;
   */
  teeth: number[];

  /**
   * @generated from field: repeated cadendar.quotes.v1.CreateQuoteLineInput quote_lines = 3;
   */
  quoteLines: CreateQuoteLineInput[];
};

/**
 * Describes the message cadendar.quotes.v1.CreateQuoteFavoriteInput.
 * Use `create(CreateQuoteFavoriteInputSchema)` to create a new message.
 */
export const CreateQuoteFavoriteInputSchema: GenMessage<CreateQuoteFavoriteInput> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 15);

/**
 * @generated from message cadendar.quotes.v1.CreateQuoteRequest
 */
export type CreateQuoteRequest = Message<"cadendar.quotes.v1.CreateQuoteRequest"> & {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;

  /**
   * @generated from field: string patient_id = 2;
   */
  patientId: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string | undefined;

  /**
   * @generated from field: repeated cadendar.quotes.v1.CreateQuoteFavoriteInput favorites = 4;
   */
  favorites: CreateQuoteFavoriteInput[];
};

/**
 * Describes the message cadendar.quotes.v1.CreateQuoteRequest.
 * Use `create(CreateQuoteRequestSchema)` to create a new message.
 */
export const CreateQuoteRequestSchema: GenMessage<CreateQuoteRequest> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 16);

/**
 * @generated from message cadendar.quotes.v1.CreateQuoteResponse
 */
export type CreateQuoteResponse = Message<"cadendar.quotes.v1.CreateQuoteResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cadendar.quotes.v1.CreateQuoteResponse.
 * Use `create(CreateQuoteResponseSchema)` to create a new message.
 */
export const CreateQuoteResponseSchema: GenMessage<CreateQuoteResponse> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 17);

/**
 * The uploaded Logos JSON file is an external interchange format, validated in Rust.
 *
 * @generated from message cadendar.quotes.v1.ImportLogosRequest
 */
export type ImportLogosRequest = Message<"cadendar.quotes.v1.ImportLogosRequest"> & {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;

  /**
   * @generated from field: string json_file = 2;
   */
  jsonFile: string;

  /**
   * @generated from field: optional string import_batch_id = 3;
   */
  importBatchId?: string | undefined;
};

/**
 * Describes the message cadendar.quotes.v1.ImportLogosRequest.
 * Use `create(ImportLogosRequestSchema)` to create a new message.
 */
export const ImportLogosRequestSchema: GenMessage<ImportLogosRequest> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 18);

/**
 * @generated from message cadendar.quotes.v1.ImportLogosResponse
 */
export type ImportLogosResponse = Message<"cadendar.quotes.v1.ImportLogosResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: uint32 count = 2;
   */
  count: number;

  /**
   * @generated from field: uint32 inserted_count = 3;
   */
  insertedCount: number;

  /**
   * @generated from field: uint32 updated_count = 4;
   */
  updatedCount: number;
};

/**
 * Describes the message cadendar.quotes.v1.ImportLogosResponse.
 * Use `create(ImportLogosResponseSchema)` to create a new message.
 */
export const ImportLogosResponseSchema: GenMessage<ImportLogosResponse> = /*@__PURE__*/
  messageDesc(file_cadendar_quotes_v1_quotes, 19);

/**
 * @generated from service cadendar.quotes.v1.QuotesService
 */
export const QuotesService: GenService<{
  /**
   * @generated from rpc cadendar.quotes.v1.QuotesService.GetPatientQuotes
   */
  getPatientQuotes: {
    methodKind: "unary";
    input: typeof GetPatientQuotesRequestSchema;
    output: typeof GetPatientQuotesResponseSchema;
  },
  /**
   * @generated from rpc cadendar.quotes.v1.QuotesService.ListTracking
   */
  listTracking: {
    methodKind: "unary";
    input: typeof ListTrackingRequestSchema;
    output: typeof ListTrackingResponseSchema;
  },
  /**
   * @generated from rpc cadendar.quotes.v1.QuotesService.UpdateTracking
   */
  updateTracking: {
    methodKind: "unary";
    input: typeof UpdateTrackingRequestSchema;
    output: typeof TrackingSchema;
  },
  /**
   * @generated from rpc cadendar.quotes.v1.QuotesService.CreateQuote
   */
  createQuote: {
    methodKind: "unary";
    input: typeof CreateQuoteRequestSchema;
    output: typeof CreateQuoteResponseSchema;
  },
  /**
   * @generated from rpc cadendar.quotes.v1.QuotesService.ImportLogosQuotes
   */
  importLogosQuotes: {
    methodKind: "unary";
    input: typeof ImportLogosRequestSchema;
    output: typeof ImportLogosResponseSchema;
  },
  /**
   * @generated from rpc cadendar.quotes.v1.QuotesService.ImportLogosActes
   */
  importLogosActes: {
    methodKind: "unary";
    input: typeof ImportLogosRequestSchema;
    output: typeof ImportLogosResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_cadendar_quotes_v1_quotes, 0);

